import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/ui/Reveal';
import { SectionLabel } from '../components/ui/SectionLabel';
import { SplitText } from '../components/ui/SplitText';
import { ProcessSection } from '../components/home/ProcessSection';
import { FaqSection } from '../components/FaqSection';
import { CtaBanner } from '../components/CtaBanner';
import { engagementModels } from '../data/process';
import { images } from '../data/images';
export function Method() {
  return <>
      <PageHero label="Méthode" title="Une méthode simple, des résultats qui se mesurent." description="Diagnostic, stratégie, négociation, déploiement, pilotage : une démarche éprouvée, adaptée à votre contexte et transparente à chaque étape." image={images.meeting} data-id="element-645" data-mp="3lhj8mt6yrro6" />

      <ProcessSection data-id="element-646" data-mp="2xsql9l4eqs56" />

      <section className="bg-white py-24 lg:py-32" data-id="element-647" data-mp="32pqpdqhp5ktn">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-648" data-mp="32p78md3s92h7">
          <SectionLabel data-id="element-649" data-mp="egt13ulfgh1d">Formats d’intervention</SectionLabel>
          <h2 className="mt-6 max-w-2xl text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-650" data-mp="ejf8nu8biwjl">
            <SplitText text="Le format qui correspond à votre besoin." data-id="element-651" data-mp="ni0ld8r3zhcg" />
          </h2>

          <Reveal delay={0.1} className="mt-14 overflow-x-auto" data-id="element-652" data-mp="nfmu7azjupa6">
            <table className="w-full min-w-[860px] border-collapse text-left" data-id="element-653" data-mp="ijfnvh38rbrp">
              <caption className="sr-only" data-id="element-654" data-mp="3qzr79beqpzpn">Comparatif des formats d’intervention</caption>
              <thead data-id="element-655" data-mp="3mxxbnhjejlwc">
                <tr className="border-b border-ink/20 text-sm text-muted" data-id="element-656" data-mp="3myfif83oxiii">
                  <th scope="col" className="py-4 pr-6 font-normal" data-id="element-657" data-mp="4jejvsrojo80">Format</th>
                  <th scope="col" className="py-4 pr-6 font-normal" data-id="element-658" data-mp="3vy2hvocv0e8x">Durée</th>
                  <th scope="col" className="py-4 pr-6 font-normal" data-id="element-659" data-mp="3vvzgk869ayow">Contenu</th>
                  <th scope="col" className="py-4 pr-6 font-normal" data-id="element-660" data-mp="386f0py5eghju">Idéal pour</th>
                  <th scope="col" className="py-4 font-normal" data-id="element-661" data-mp="338ltr2w9vjii">Livrable</th>
                </tr>
              </thead>
              <tbody data-id="element-662" data-mp="175qlorzpcc57">
                {engagementModels.map(m => <tr key={m.name} className="border-b border-ink/10 align-top" data-id="element-663" data-mp="1c3sdq2f3vlst">
                    <th scope="row" className="py-6 pr-6 text-lg font-medium" data-id="element-664" data-mp="1gvjvbngaah6t">{m.name}</th>
                    <td className="whitespace-nowrap py-6 pr-6 text-brass-dark" data-id="element-665" data-mp="1lvejvkcl6uop">{m.duration}</td>
                    <td className="py-6 pr-6 text-muted" data-id="element-666" data-mp="o7ny8hmsyn9i">{m.format}</td>
                    <td className="py-6 pr-6 text-muted" data-id="element-667" data-mp="o9h8s80jdrms">{m.ideal}</td>
                    <td className="py-6 text-ink" data-id="element-668" data-mp="t6r2w0yvergy">{m.deliverable}</td>
                  </tr>)}
              </tbody>
            </table>
          </Reveal>
        </div>
      </section>

      <FaqSection data-id="element-669" data-mp="128gvvb8ehygu" />
      <CtaBanner data-id="element-670" data-mp="124t52jucbq5t" />
    </>;
}